import { AppSidebar } from "@humanex/ui/components";
import { cn } from "@humanex/ui/libs";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { BookOpen, CircleUser, LayoutDashboard, Network, Users } from "lucide-react";

import { Logo } from "@/components";

const NAV_ITEMS = [
  { to: "/home", label: "Dashboard", icon: LayoutDashboard },
  { to: "/candidates", label: "Ứng viên", icon: Users },
  { to: "/tree", label: "Cây đại lý", icon: Network },
  { to: "/programs", label: "Chương trình", icon: BookOpen },
  { to: "/profile", label: "Hồ sơ", icon: CircleUser }
] as const;

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

export function Sidebar({ open, onClose }: SidebarProps) {
  const match = useMatchRoute();

  return (
    <AppSidebar
      open={open}
      onClose={onClose}
      collapseBelow="md"
      className="w-56 md:w-14 lg:w-56 border border-white bg-white/95 md:bg-white/80 rounded-r-3xl md:rounded-3xl shadow-sm"
    >
      <div className="py-4 border-b border-primary-100 flex flex-col justify-center gap-2 items-center">
        <Logo className="h-16 w-40 md:h-10 md:w-10 lg:h-16 lg:w-40" />
        <span className="md:hidden lg:block text-responsive-lg font-medium text-primary">AGENT PORTAL</span>
      </div>
      <nav className="flex-1 py-4 space-y-0.5 px-2">
        {NAV_ITEMS.map((item) => {
          const isActive = match({ to: item.to });
          return (
            <Link
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={cn(
                "flex items-center gap-2 px-3 py-2 rounded text-responsive-md transition-colors",
                "md:justify-center lg:justify-start",
                isActive ? "bg-primary-100/80 text-primary font-medium" : "text-slate-400 hover:bg-primary-50"
              )}
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              <span className="md:hidden lg:inline">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </AppSidebar>
  );
}
